import { useRef } from "react";

import { useGlobal } from "../contexts/globalContext";

import { Video } from "./video-element";

const MeetingThumbCams = function () {
  // TODO: this component is used only in the fullscreen mode to invite new participants.
  const { MEETING_STATE } = useGlobal();

  const webcamVideoRef = useRef(null);

  const handleClick = (e, idx) => {
    if (document.fullscreenElement) return;
    console.log(idx);
  };

  if (MEETING_STATE.users.active.length === 0) {
    return (
      <div
        className={`meeting-thumb-videos no-users ${MEETING_STATE.currentUser} ${MEETING_STATE.currentUser.isVideoMuted} ${MEETING_STATE.currentUser?.isVideoMuted?.local}`}
        style={{ width: 69 }}>
        <div>
          <Video ref={webcamVideoRef} autoPlay muted className={MEETING_STATE.currentUser?.isVideoMuted?.local ? "hide" : ""} />
        </div>
      </div>
    );
  }

  const renderThumbVideos = () =>
    MEETING_STATE.users.active.map((user) => (
      <div key={user.idx} onClick={(e) => handleClick(e, user.idx)}>
        <Video
          autoPlay
          muted={MEETING_STATE.currentUser.pid === user.pid}
          srcObject={MEETING_STATE.currentUser.pid === user.pid ? MEETING_STATE.webcamStream : MEETING_STATE.meetingVideoStream}
          style={{
            left: 0,
            top: MEETING_STATE.currentUser.pid === user.pid ? 0 : user.idx * -52,
          }}
        />
        <label>{user.meeting_uname}</label>
      </div>
    ));

  return <div className="meeting-thumb-videos are-users">{renderThumbVideos()}</div>;
};

export default MeetingThumbCams;
